import Breadcrumb from './src/breadcrumb.vue';

/* istanbul ignore next */
Breadcrumb.install = function(Vue) {
  Vue.component('Breadcrumb', Breadcrumb);
};
export default Breadcrumb;


// WEBPACK FOOTER //
// ./src/components/base/view/cmps/breadcrumb/index.js